<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="skeleton__wrapper mb-12">
    <CiSkeletonItem class="h-[66px] w-full" />

    <div class="container my-3">
      <CiSkeletonItem class="mt-4 h-16 w-full lg:h-[38px]" />
      <CiSkeletonItem class="mb-12 h-[75px] w-full lg:h-[43px]" />
      <CiSkeletonItem class="mb-2 h-[66px] w-full" />
      <CiSkeletonItem class="mb-12 h-[400px] w-full" />
      <CiSkeletonItem class="mb-12 h-[92px] w-full lg:w-1/2" />
      <CiSkeletonItem class="mb-12 h-[100px] w-full" />

      <div class="my-4 grid grid-cols-12 md:gap-x-[30px]">
        <div class="order-2 col-span-12 mt-4 md:order-1 md:col-span-6 md:mt-0 lg:col-span-3 lg:col-start-4">
          <CiSkeletonItem class="h-10 w-full" />
        </div>
        <div class="order-1 col-span-12 md:order-2 md:col-span-6 lg:col-span-3">
          <CiSkeletonItem class="h-10 w-full" />
        </div>
      </div>
    </div>
  </div>
</template>
